<div id="recurring-table">
    <span class="section-title" id="account-transactions-header">Recurring transactions</span>
    <mm-table [columnDefs]="columnDefs" [defaultColumnDefs]="defaultColumnDefinitions" [rowData]="rowData$ | async" [presetFilters]="filterModel"
      [noExportCol]="noExportCol" [fileName]="fileName" [tableName]="'recurring'"
      [componentState$]="transactionsTableState$" [showFilterCount]="true" [showTableOptions]="true"
      [showFloatingFilter]="true" [headerHeight]="25" [rowHeight]="25"></mm-table>
    <mm-cancel-link-modal [showModal$]="cancelLinkClickedAsObservable$" [id]="'cancel-link-modal'"></mm-cancel-link-modal>
    <delete-standing-auth-modal [showModal$]="deleteLinkClickedAsObservable$" [currentTransaction$]="currentSelectedTransactionAsObservable$"></delete-standing-auth-modal>
  </div>
